import { useQuery } from '@apollo/client';
import { useUser } from '../../useUser';
import { ADDRESSES_QUERY, AddressesQuery } from './addressesQuery.rest';

type UseAddressesQueryOptions = {
  skip?: boolean;
};

export const useAddressesQuery = (options?: UseAddressesQueryOptions) => {
  const {
    user: { accessToken }
  } = useUser();
  const { data, loading, error } = useQuery<AddressesQuery>(ADDRESSES_QUERY, {
    skip: !accessToken || options?.skip
  });

  return { addresses: data?.addresses.data || [], fetched: data != null, loading, error };
};
